import apiClient from "../apiClient";

const resource = "dashboard";

export default {
    getStatistics: () => apiClient.get(`${resource}`),
    getAppointmentsByDoctor: () => apiClient.get(`${resource}/AppointmentsByDoctor`),
    getSalesByMonth: () => apiClient.get(`${resource}/SalesByMonth`),

};
